import React from "react";
import {Select} from "antd";
import {SelectField} from "./CreditModeSelect.style";
import {useFetch} from "hooks/useFetch";
import {useStore} from "hooks/useStore";

export const CreditModeSelect = ({
    value,
    onChange,
    disabled = false,
    allowClear = false,
    showTitle = true,
    title = "Kredi Modu",
    placeholder = "Kredi modu seçiniz",
    marginBottom = "20px",
    style = {},
    ...props
}) => {
    const stores = useStore();

    const [loading, creditModeOptions] = useFetch({
        fetchFn: stores.companyStore.creditModes.bind(null),
        initialCall: true
    });

    return (
        <React.Fragment>
            {showTitle && <h5>{title}</h5>}
            <SelectField
                data-testid="creditModeSelect"
                value={value}
                onChange={onChange}
                disabled={disabled || loading}
                loading={loading}
                allowClear={allowClear}
                placeholder={placeholder}
                style={{marginBottom, ...style}}
                {...props}
            >
                {creditModeOptions?.map(creditMode => (
                    <Select.Option key={creditMode?.value} value={creditMode?.value}>
                        {creditMode?.label || "-"}
                    </Select.Option>
                ))}
            </SelectField>
        </React.Fragment>
    );
};
